import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";
import { Link } from "react-router-dom";

const MutualFunds = () => {
  useEffect(() => {
    window.scrollTo(0, 0);

    if (window.jQuery) {
      const $ = window.jQuery;

      if ($.fn.tab) {
        $(".tab1").tab();
        $(".tab2").tab({ trigger_event_type: "mouseover" });
      }

      if ($.fn.owlCarousel) {
        const $carousel = $(".owl-carousel");
        $carousel.owlCarousel({
          items: 3,
          loop: true,
          margin: 30,
          dots: true,
          autoplay: true,
          autoplayTimeout: 2000,
          responsive: {
            0: { items: 1 },
            600: { items: 2 },
            1000: { items: 3 },
          },
        });

        return () => {
          if ($carousel.data("owl.carousel")) {
            $carousel.data("owl.carousel").destroy();
          }
        };
      }
    }
  }, []);

  return (
    <div className="mutual-funds-page">
      <SEO
        title="Mutual Funds Investment"
        description="Diversified mutual fund schemes across leading Asset Management Companies (AMCs). Goal-based investment planning with research-backed guidance."
      />

      {/* Banner */}
      <section className="service-banner">
        <img
          src="/images/banners/mutual-banner.avif"
          alt="Mutual Fund Banner"
          loading="eager"
          id="service-desktop-banner"
        />
        <img
          src="/images/banners/mutual-mobile-banner.avif"
          alt="Mutual Fund Mobile Banner"
          loading="eager"
          id="service-mobile-banner"
        />
        <div className="services-banner-content">
          <h1 data-aos="fade-up">
            Mutual <span>Funds</span>
          </h1>
          <div className="banner-highlights" data-aos="fade">
            <span>Invest</span>
            <span>Grow</span>
            <span>Secure</span>
          </div>
        </div>
      </section>

      {/* Services We Offer */}
      <section className="offered-services">
        <div className="container">
          <div className="offered-services-left">
            <h2 data-aos="fade-up">
              <span>What</span> <br /> We Offer
            </h2>
            <p>
              We offer access to a comprehensive range of mutual fund schemes
              across leading Asset Management Companies (AMCs), enabling
              investors to build diversified portfolios aligned with long-term
              financial goals. Our approach emphasizes disciplined asset
              allocation, risk profiling, and ongoing portfolio review to ensure
              investments remain aligned with evolving market conditions and
              personal objectives.
            </p>
            <p>
              Whether your focus is capital appreciation, tax efficiency under
              Section 80C, systematic wealth creation through SIPs, or
              generating stable income, we provide structured guidance supported
              by research and performance analytics.
            </p>
          </div>
          <div className="offered-services-right">
            <img
              src="/images/services/mutual-offer.avif"
              alt="Mutual Funds"
              loading="lazy"
            />
          </div>
        </div>

        <img
          src="/images/services/offer-bg.avif"
          alt="Background decoration"
          className="offer-bg"
        />
      </section>

      {/* Services Divider */}
      <section className="services-divider">
        <div className="services-divider-left"></div>
        <div className="services-divider-right"></div>
      </section>

      {/* Services Highlights */}
      <section className="services-highlights">
        <div className="container">
          <div className="services-highlights-left">
            <h2 data-aos="fade-up">Key Highlights</h2>
            <p>
              Diversified investment solutions managed by experts to balance
              risk and return. Flexible options and long-term growth potential
              help you stay aligned with your financial goals.
            </p>
            <img
              src="/images/services/mutual-highlight.png"
              alt="Highlight graphic"
              loading="lazy"
            />
          </div>

          <div className="services-highlights-right">
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Goal-based investment planning</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>SIP, STP & SWP facilities</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Diversified equity, debt & hybrid schemes</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Portfolio monitoring & review support</p>
            </div>
            <div className="highlight-item" data-aos="fade">
              <span className="bullet-icon"></span>
              <p>Tax-saving (ELSS) investment options</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Disclaimer */}
      <section className="services-disclaimer">
        <div className="container">
          <p>
            <b>Disclaimer</b>: Mutual Fund investments are subject to market
            risks. Please read all scheme-related documents carefully before
            investing. Past performance may or may not be sustained in the
            future.
          </p>
        </div>
      </section>

      {/* Services App Download */}
      <section className="services-app-download">
        <div className="container">
          <div className="services-app-download-left">
            <img
              src="/images/download.avif"
              alt="App Download"
              loading="lazy"
            />
          </div>
          <div className="services-app-download-right">
            <h3 data-aos="fade-up">
              Download Our <br /> Investment Fund App
            </h3>
            <p>Investing With Gateway Financial Services Limited</p>
            <Link to="/" className="download-btn lm-btn">
              Download Now
            </Link>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default MutualFunds;
